// import _ from 'lodash';

export const setLogoutTimeout = logout => {
  const MINUTES = 1000 * 60// * 10 10 minutes
  setTimeout(logout, MINUTES);
}

export const isUserValid = user => user && user.pin_code_present;